/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonEpochRequest = {
    sortField?: BabylonEpochRequest.sortField;
    sortDirection?: BabylonEpochRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace BabylonEpochRequest {

    export enum sortField {
        EPOCH_NUMBER = 'EPOCH_NUMBER',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

